import EnergyLabel from './energy-label'

export default EnergyLabel
